import store from 'store';

export const DEFAULT_LANE_NAME = 'No Status'

export const mapTicketsToLanes = ({ tickets, lanes }) => {
  const [draft, closed, open, nonLane] = [[], [], [], []];
  const {
    cards: { filters },
  } = store.getState();

  const showClosed = filters?.active?.values?.includes(false);

  for (let t of tickets) {
    //Dnd wants string ids
    t.id = `${t.id}`;

    const { submitted_at, closed_at, lane_id } = t;
    if (!submitted_at) draft.push(t);
    if (closed_at) closed.push(t);
    if (submitted_at && !closed_at && lane_id) open.push(t);
    if (submitted_at && !closed_at && !lane_id) nonLane.push(t);
  }

  const sorted = lanes.map(({ id, name, disabled }) => {
    return {
      id: `${id}`,
      name,
      disabled,
      cards: open.filter(({ lane_id }) => lane_id === id),
    };
  });

  const closedId = sorted.length + 3;

  const draftSort = (a, b) => {
    if (a.submission_due_at && b.submission_due_at) {
      return new Date(a.submission_due_at) - new Date(b.submission_due_at);
    }
    if (a.submission_due_at || b.submission_due_at) {
      return a.submission_due_at ? -1 : 1;
    }
    return a.id - b.id;
  };

  const data = [];
  if (draft.length > 0) {
    data.push({
      id: '1',
      name: 'Draft',
      disabled: true,
      cards: draft.sort(draftSort),
    });
  }

  if (nonLane.length > 0) {
    data.push({
      id: '2',
      name: DEFAULT_LANE_NAME,
      cards: nonLane,
    });
  }

  data.push(...sorted);

  if (showClosed && closed.length > 0) {
    data.push({
      id: `${closedId}`,
      name: 'Closed',
      cards: closed,
    });
  }

  return data;
};
